var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItaly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.847,
    height: 37.848,
    viewBox: "0 0 37.847 37.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f0f0f0;}.b{fill:#fa0b54;}.c{fill:#84c654;}.d{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 37.847,
    height: 37.848,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.539 5.539)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, -8.54, -5.54)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 9.923,
    cy: 9.924,
    rx: 9.923,
    ry: 9.924,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 9.571,
    cy: 10,
    rx: 9.571,
    ry: 10,
    transform: "translate(0.462 0.462)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M351.192,25.265a9.956,9.956,0,0,0-6.149-9.342V34.608A9.956,9.956,0,0,0,351.192,25.265Z",
    transform: "translate(-331.192 -14.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,25.265a9.956,9.956,0,0,0,6.149,9.342V15.923A9.956,9.956,0,0,0,0,25.265Z",
    transform: "translate(0 -14.91)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItaly);
export default __webpack_public_path__ + "static/media/italy.aa6b64e386295b6f8712614618527a15.svg";
export { ForwardRef as ReactComponent };